@let fn = myFunction();

@if (fn)
{
  <div class="step2">
    <!-- The dimming overlay belongs to the "copied to clipboard" toast and is bound to the same
         signal: the original faded both in together and back out after 1.5s
         (`$('.copiedClipboard, .overlayModal').fadeIn('fast').delay(1500).fadeOut('fast')` in
         gmr-app.js). Only the toast itself had been ported, so the message appeared over an
         undimmed form. Both default to display:none in menu.css, hence the explicit binding. -->
    <div class="overlayModal" [style.display]="showCopiedToast() ? 'block' : 'none'"></div>
    <div class="copiedClipboard" [style.display]="showCopiedToast() ? 'block' : 'none'"><span class="copySuccess" translate="itgen_gmr_copied"></span></div>
    <div class="successModal">
      <span class="succesSpan" translate="itgen_gmr_success"></span>
    </div>

    <!-- .slideIn2 defaults to display:none in menu.css; goBookmark() fadeIn()'d it, this mirrors that. -->
    <div class="slideIn2" [style.display]="ui.step() === 'parameterForm' ? 'block' : 'none'">
      <nav aria-label="breadcrumbs">
        <ol class="breadcrumb">
          <!-- The original menu.html had a hard-coded English "Home" as this link's text; it went
               missing in the Angular port, leaving an empty <a> and a bare "»". Restored through
               itgen_gmr_home - the same key the sidebar's home link already uses - so it follows the
               user's language instead of being English for everyone. -->
          <li class="breadcrumb-item home"><a href="/menu.html" class="bsrBack functionsLogo" data-transaction-name="Back" insp-label="Back" [title]="'itgen_gmr_main' | translate | decodeEntities" translate="itgen_gmr_home" (click)="ui.goToFunctionPicker($event)"></a></li>
          <li class="separator"></li>
          <li class="breadcrumb-item active" [translate]="fn.cfn_description"><span></span></li>
        </ol>
      </nav>
      <h2 class="heading">
        <span class="moduleHeading" [translate]="fn.cfn_description"></span>
      </h2>
      <div id="chooseFilter">
        <div class="moduleHeadingWrapper">
          <div class="explanationWrap" [class.hide]="fn.cfn_documentation_i18n == null">
            <p #explanationContent class="explanationContent" [class.maxHeight]="explanationTruncatable()" [class.more]="explanationExpanded()" (click)="toggleExplanation()" [translate]="fn.cfn_documentation ?? ''"></p>
          </div>
          <span class="moduleWrap copyClipboard" [title]="'itgen_gmr_bookmark' | translate | decodeEntities" (click)="onCopyBookmarkClick()"></span>
          <a class="moduleWrap moduleHelp" href="https://go.invantive.com/doc/invantive-get-my-report-for-exact-online/{{ fn.cfn_preset_name }}" target="_blank" [attr.data-transaction-name]="'itgen_gmr_module_help' | translate | decodeEntities" [attr.insp-label]="'itgen_gmr_module_help' | translate" [title]="'itgen_gmr_module_help' | translate | decodeEntities"></a>
        </div>

        <div class="form presets">
          <!-- No `target` here any more. A GET report never submits natively at all - it is fetched,
               so the page can see it start, finish and fail. A POST report still submits natively, and
               DownloadService points the form at a hidden iframe of its own just before it does: one
               iframe per download, because every form sharing one name meant a second submit navigated
               the same browsing context and dropped a first request that was still generating. -->
          <!-- Validation is the browser's: plain inputs carry [required], and the LOV selects get a
               setCustomValidity message on the real <input> ng-select renders, so every field reports
               through the same native mechanism. See LovSelectComponent.updateValidity. -->
          <form #form name="presets" action="Preset" [attr.method]="formMethod()" [attr.enctype]="fn.cfn_form_encoding" [id]="fn.cfn_preset_name" (submit)="onSubmit($event)">
            <input type="hidden" [value]="fn.cfn_preset_name" name="preset" />

            <!-- Mobile-only duplicate of the bottom submit button (shown once goToParameterForm()
                 detects a mobile/Android user agent, so it's reachable without scrolling down past
                 a long parameter list). Was ported with type="button" and no [class.show] binding -
                 neither ever wired up, so it stayed permanently hidden and inert; the original had
                 type="submit" (its own ng-click was a dead no-op expression, same class of bug as
                 the main button - see onSubmit's own comment). Neither button carries [disabled]
                 any more: both submit, and onSubmit() blocks an incomplete form and explains why.
                 -
                 @if, rather than rendering it always and hiding it with .hide: on a desktop the form
                 used to contain TWO submit buttons reading "Download", one of them invisible, so
                 anything selecting "the download button" by text or class could pick the one that
                 cannot be clicked. showMobileDownloadButton() is only ever set on a mobile user agent
                 and never cleared, so there is nothing to toggle back and no reason to keep the
                 element around on the surface where it is never used. The .hide/.show classes stay
                 for the mobile layout itself. -->
            @if (ui.showMobileDownloadButton())
            {
              <button class="requestButton download hide show" type="submit" [id]="'btn-submit-mobile-' + fn.cfn_preset_name" data-transaction-name="Download" insp-label="Download">{{ actionButtonLabel() }}</button>
            }

            <ul>
              @for (param of myFunctionParameters(); track param.cfr_code; let i = $index)
              {
                <app-parameter-field [parameter]="param" [lovRows]="myLovPresets()[i] ?? []" [presetName]="fn.cfn_preset_name"></app-parameter-field>
              }
            </ul>

            <!-- No [title] any more. It carried the report's description ("Artikelen") while the
                 button's visible text is "Download", so the tooltip named the page rather than the
                 action - and every accessibility-tree reader we drive this app with reported the button
                 as "Artikelen", which makes the primary action of every report unfindable by its own
                 label. Per HTML-AAM a button's contents outrank its title, so Chrome's own computed name
                 was most likely already "Download"; the tools disagreeing with the spec is reason enough,
                 since a name that only one consumer resolves correctly is not a name to rely on. The
                 description still reaches analytics through data-transaction-name and insp-label, which
                 is what it was there for. -->
            <div class="buttonbar">
              <button class="requestButton download" type="submit" [id]="'btn-submit-' + fn.cfn_preset_name" [attr.data-transaction-name]="fn.cfn_description | translate" [attr.insp-label]="fn.cfn_description | translate">{{ actionButtonLabel() }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
}
